// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GwuHM","importantInfo":"styles_importantInfo__1xUsz"};